<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>党费系统</el-breadcrumb-item>
        <el-breadcrumb-item>缴费管理</el-breadcrumb-item>
        <el-breadcrumb-item>缴费人员</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="hx-form-container box-shadow">
      <el-form ref="listForm" inline :model="listParams" label-width="100px">
        <el-form-item label="缴费月份：" prop="timeInterval">
          <el-date-picker
            v-model="listParams.timeInterval"
            type="monthrange"
            range-separator="至"
            start-placeholder="开始月份"
            end-placeholder="结束月份"
          />
        </el-form-item>

        <el-form-item label="人员：" prop="partyMember">
          <el-input
            size="small"
            placeholder="请输入缴费人员"
            v-model="listParams.partyMember"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="手机号：" prop="phoneNumber">
          <el-input
            size="small"
            placeholder="请输入手机号"
            v-model="listParams.phoneNumber"
          >
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="handleRefresh">
            查询
          </el-button>

          <el-button size="small" @click="$refs['listForm'].resetFields()">
            重置
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <hx-table-result
      :page-info="pager"
      :loading="tableLoading"
      @page-current-change="handleCurrentChange"
      @page-size-change="handleSizeChange"
    >
      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display" style="height: 32px;">
          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table slot="content" :data="tableData" max-height="800" border>
        <el-table-column width="80" align="center" label="序号">
          <template slot-scope="scope">
            <span
              v-text="
                (pager.pageIndex > 1
                  ? (pager.pageIndex - 1) * pager.pageSize
                  : 0) +
                  scope.$index +
                  1
              "
            >
            </span>
          </template>
        </el-table-column>

        <el-table-column prop="paymentStatus" align="center" label="缴费状态">
          <template slot-scope="scope">
            <span v-if="scope.row.paymentStatus === 0" style="color: gray;"
              >已截止</span
            >
            <span v-if="scope.row.paymentStatus === 1" style="color: green;"
              >已缴费</span
            >
            <span v-if="scope.row.paymentStatus === 2" style="color: red;"
              >未缴费</span
            >
          </template>
        </el-table-column>

        <el-table-column prop="paymentMonth" align="center" label="缴费月份">
        </el-table-column>

        <el-table-column prop="partyMember" align="center" label="人员">
        </el-table-column>

        <el-table-column prop="phoneNumber" align="center" label="手机号">
        </el-table-column>

        <el-table-column prop="groupName" align="center" label="分组">
        </el-table-column>

        <el-table-column
          prop="partyMemberDues"
          align="center"
          label="缴纳党费(元)"
        >
          <template slot-scope="scope">
            <span style="color: red;">{{
              scope.row.partyMemberDues | formatToFixed2("元")
            }}</span>
            <span>{{ scope.row.firstPay === 0 ? "(补)" : "" }}</span>
          </template>
        </el-table-column>
      </el-table>
    </hx-table-result>
  </div>
</template>

<script>
import Vue from "vue";
export default {
  data() {
    return {
      listParams: {
        timeInterval: ["", ""],
        partyMember: "",
        phoneNumber: ""
      },
      pager: {
        total: 0,
        pageIndex: 1,
        pageSize: 15
      },
      tableData: [],
      tableLoading: false
    };
  },
  mounted() {
    this.handleRefresh();
  },
  methods: {
    handleRefresh() {
      this.pager.pageIndex = 1;
      this.loadTableData();
    },
    /**
     * 加载列表数据Ω
     */
    loadTableData() {
      const bodyParams = Object.assign({}, this.listParams, this.pager);
      if (bodyParams.timeInterval && bodyParams.timeInterval.length == 2) {
        bodyParams.startDate = bodyParams.timeInterval[0].valueOf();
        bodyParams.endDate = bodyParams.timeInterval[1].valueOf();
      }
      delete bodyParams.timeInterval;
      delete bodyParams.total;
      Vue.ajaxGet(
        this,
        global.apiUrl + "/partyFee/getPaidPartyFeeList",
        bodyParams,
        "tableLoading"
      ).then(res => {
        this.tableData = res.dataList;
        this.pager.total = res.total;
      });
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    }
  }
};
</script>

<style lang="less" scoped>
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
}
</style>
